import useSWR from 'swr-0-5-6';
import urlcat from 'urlcat';
import { apirc } from '~/configs/apirc';
const fetcher = async (url) => {
    const res = await fetch(url);
    if (res.status >= 400)
        throw new Error();
    return res.json();
};
/** 股期商品近遠月分數 */
export const useStkWeightResource = (date) => {
    const url = urlcat(apirc.unclassified.stkfutWeightURL.toString(), { date });
    const res = useSWR(url, fetcher, {
        revalidateOnFocus: false,
        refreshInterval: 15000,
    });
    return {
        data: res.data ? res.data : [],
        isLoading: !res.data && !res.error,
    };
};
